import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@turfchale/supabase'

export const Route = createFileRoute('/app')({
  beforeLoad: ({ location }) => {
    const { profile } = useAuthStore.getState()
    if (!profile) throw redirect({ search: { redirect: location.pathname }, to: '/auth' })
  },
  component: () => <Outlet />,
})
